import * as Accordion from '@radix-ui/react-accordion';
import { TextField, withDatasourceCheck } from '@sitecore-jss/sitecore-jss-nextjs';
import classNames from 'classnames';

import { icon_plus } from '@gn-audio/icons';
import {
  JabraIcon,
  mapSharedPropertiesToFields,
  resolveColorProperty,
} from '@gn-audio/jss-components';
import { ComponentProps } from '@gn-audio/jss-components/lib/component-props';

type KSPHiddenInfoSpotProps = {
  fields: KSPHiddenInfoSpot;
} & ComponentProps;

type KSPHiddenInfoSpot = {
  textBoxBackgroundColor: TextField;
  textBoxBackgroundColorShared: TextField;
  textBoxFontColor: TextField;
  textBoxFontColorShared: TextField;
  textBoxContent: TextField;
  textBoxContentShared: TextField;
  buttonBackgroundColor: TextField;
  buttonBackgroundColorShared: TextField;
  buttonTextColor: TextField;
  buttonTextColorShared: TextField;
  buttonText: TextField;
  buttonTextShared: TextField;
};

const KSPHiddenInfoSpot = ({ fields }: KSPHiddenInfoSpotProps) => {
  const {
    textBoxBackgroundColor,
    textBoxFontColor,
    buttonBackgroundColor,
    buttonTextColor,
    buttonText,
    textBoxContent,
  } = mapSharedPropertiesToFields<KSPHiddenInfoSpot>(fields);

  const textBoxBackgroundStyles = {
    backgroundColor: resolveColorProperty(textBoxBackgroundColor.value as string),
    color: resolveColorProperty(textBoxFontColor.value as string),
  };

  const buttonBackgroundStyles = {
    backgroundColor: resolveColorProperty(buttonBackgroundColor.value as string),
    color: resolveColorProperty(buttonTextColor.value as string),
  };

  const buttonGapClass = buttonText.value ? 'gap-2 md:gap-5' : 'gap-0';

  const accordionItemRandomValue = crypto.randomUUID();

  return (
    <>
      {textBoxContent?.value && (
        <div className="container relative">
          <div className="flex w-full flex-col">
            <Accordion.Root type="single" collapsible>
              <Accordion.Item value={`item-${accordionItemRandomValue}`}>
                <div className="relative">
                  <Accordion.Trigger className="group absolute left-1/2 top-0 -translate-x-1/2 -translate-y-1/2 transform">
                    <div
                      style={buttonBackgroundStyles}
                      className={classNames(
                        buttonGapClass,
                        'flex min-w-max cursor-pointer items-center rounded-full px-5 py-4 text-base font-bold'
                      )}
                    >
                      <JabraIcon
                        iconStyle={{ strokeWidth: 2 }}
                        className={`transition-transform duration-500 ease-in-out group-data-[state=open]:rotate-45`}
                        Icon={icon_plus}
                      />
                      <span>{buttonText.value}</span>
                    </div>
                  </Accordion.Trigger>
                  <Accordion.Content
                    className="collapsible-content rounded-3xl duration-500"
                    style={textBoxBackgroundStyles}
                  >
                    <div className="px-4 py-10 sm:px-16 sm:py-20 lg:px-32">
                      <p
                        className="text-xl"
                        dangerouslySetInnerHTML={{ __html: textBoxContent.value as string }}
                      ></p>
                    </div>
                  </Accordion.Content>
                </div>
              </Accordion.Item>
            </Accordion.Root>
          </div>
        </div>
      )}
    </>
  );
};

export default withDatasourceCheck()(KSPHiddenInfoSpot);
